import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListProducts(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    createOrUpdateProduct(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    deleteProduct(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()